import axios, { type AxiosError } from "axios";
import { api } from "@/lib/axios";
import type { EventApiResponse } from "@/lib/humhub-api/types";

export interface LinkMetadata {
  title?: string;
  description?: string;
  image?: string;
  siteName?: string;
  favicon?: string;
  error?: string;
  // イベント専用フィールド
  isEvent?: boolean;
  eventData?: EventApiResponse;
}

function isAxiosError(error: unknown): error is AxiosError {
  return axios.isAxiosError(error);
}

export const linkPreviewApi = {
  /**
   * URLからリンクプレビューのメタデータを取得する
   * @param url プレビューを取得するURL
   * @returns リンクメタデータ
   */
  getLinkPreview: async (url: string): Promise<LinkMetadata> => {
    try {
      const response = await api.get<LinkMetadata>(
        `/linkpreview?url=${encodeURIComponent(url)}`,
      );
      return response.data;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        if (!error.response) {
          throw new Error("Please check your connection");
        }
        if (error.response.status !== 404) {
          console.error("Link Preview API Error:", error.response.data);
        }
        throw error;
      }
      throw new Error("Unexpected error occurred");
    }
  },
};
